import CreateKantLista from '../../../Components/Kant-Lista/create-Kantlista';

const NewKantList = () => {
  return (
    <div>
      <CreateKantLista />
    </div>
  );
};

export default NewKantList;
